import * as React from 'react';
import NumberFormat from 'react-number-format';
import { WrappedFieldProps } from 'redux-form';

const containerClassName = (isPhone: boolean) => (isPhone ? 'input-group' : '');
const errorClassName = (isPhone: boolean) =>
  isPhone ? 'invalid w-100' : 'invalid';

interface IFormNumberProps {
  placeholder?: string;
  disabled?: boolean;
  inputFormat: string;
  mask?: string[];
  isPhone?: boolean;
  autoFocus?: boolean;
}

export default function FormNumber(
  props: WrappedFieldProps & IFormNumberProps,
) {
  const {
    input,
    placeholder = '',
    disabled = false,
    inputFormat,
    mask = [],
    isPhone = false,
    autoFocus = false,
    meta: { touched, error },
  } = props;

  return (
    <div className={containerClassName(isPhone)}>
      {isPhone && (
        <div className="input-group-prepend">
          <span className={"input-group-text" + (touched && error ? " invalid-form-input" : "")} id="basic-addon1">
            +56
          </span>
        </div>
      )}
      <NumberFormat
        {...input}
        id={input.name}
        className={"form-control" + (error && touched ? " invalid-form-input" : "")}
        placeholder={placeholder}
        disabled={disabled}
        format={inputFormat}
        mask={mask}
        autoFocus={autoFocus}
      />
      {touched && error && (
        <small className={errorClassName(isPhone)}>{error}</small>
      )}
    </div>
  );
}
